"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _6P52IAFYcjs = require('./6P52IAFY.cjs');



var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/combobox/combobox-context.tsx
var _react = require('react');
var ComboboxListRoleContext = _react.createContext.call(void 0, 
  void 0
);
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_6P52IAFYcjs.PopoverContextProvider, _UCZW3OGHcjs.CompositeContextProvider],
  [_6P52IAFYcjs.PopoverScopedContextProvider, _UCZW3OGHcjs.CompositeScopedContextProvider]
);
var useComboboxContext = ctx.useContext;
var useComboboxScopedContext = ctx.useScopedContext;
var useComboboxProviderContext = ctx.useProviderContext;
var ComboboxContextProvider = ctx.ContextProvider;
var ComboboxScopedContextProvider = ctx.ScopedContextProvider;
var ComboboxItemValueContext = _react.createContext.call(void 0, 
  void 0
);
var ComboboxItemCheckedContext = _react.createContext.call(void 0, false);










exports.ComboboxListRoleContext = ComboboxListRoleContext; exports.useComboboxContext = useComboboxContext; exports.useComboboxScopedContext = useComboboxScopedContext; exports.useComboboxProviderContext = useComboboxProviderContext; exports.ComboboxContextProvider = ComboboxContextProvider; exports.ComboboxScopedContextProvider = ComboboxScopedContextProvider; exports.ComboboxItemValueContext = ComboboxItemValueContext; exports.ComboboxItemCheckedContext = ComboboxItemCheckedContext;
